import React, { Component } from "react";

class UploadDocument extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isDragging: false,      
    };
  }

  convertToBytes = (x) => {
    const units = ["bytes", "KB", "MB"];
    let l = 0,
      n = parseInt(x, 10) || 0;

    while (n >= 1024 && ++l) {
      n = n / 1024;
    }

    return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
  };

  handleDragOver = (e) => {
    e.preventDefault();
    // setIsDragging(true);
    this.setState({ isDragging: true });
  };

  handleDragLeave = () => {
    // setIsDragging(false);
    this.setState({ isDragging: false });
  };

  handleDrop = (event) => {
    event.preventDefault();
    this.setState({ isDragging: false });
    const { onFileChange } = this.props;
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      // simulate the same handler as <input type="file" />
      onFileChange({ target: { files: event.dataTransfer.files } });
      event.dataTransfer.clearData();
    }
  };

  render() {
    const {
      documents,
      onFileChange,
      handleFileRemove,
      btnLable,
      acceptedFile,
    } = this.props;

    const { isDragging } = this.state;

    return (
      <div>
        {/* Upload dropdown */}
        <div className="dropdown col-md-12 text-right pr-0">
          {/* <button
            className="btn btn-outline-default btn-sm dropdown-toggle mr-0"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i className="fa fa-paperclip mr-2" aria-hidden="true"></i>
            {btnLable ? btnLable : "Add"}
          </button> */}
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a className="dropdown-item">
              <label
                htmlFor="AdhocMessagedocName"
                className="custom-file-upload mb-0"
              >
                <i className="fa fa-desktop mr-2" aria-hidden="true" />
                Upload from Local Drive
              </label>
              <input
                id="AdhocMessagedocName"
                type="file"
                style={{ display: "none" }}
                onChange={(event) => onFileChange(event)}
                name="files"
                multiple
                accept={acceptedFile}
              />
            </a>
          </div>
        </div>

        {/* Drag & Drop area */}
        <div
          className={`drop-zone w-100 p-4 mb-3 text-center border rounded ${isDragging ? "bg-light" : ""}`}
          // onDrop={this.handleDrop}
          onDragOver={this.handleDragOver}
          onDragLeave={this.handleDragLeave}
          onDrop={this.handleDrop}
          // onDragOver={(e) => e.preventDefault()}
          style={{
            border: "2px dotted #ccc",
            borderRadius: "8px",
            padding: "30px",
            textAlign: "center",
            background: isDragging ? "#f0f8ff" : "#fafafa",
            cursor: "pointer",
            transition: "background 0.2s ease",
          }}
          onClick={() =>
            document.getElementById("AdhocMessagedocName").click()
          }
        >
          <i className="fa fa-cloud-upload fa-2x mb-2" aria-hidden="true"></i>
          <p className="mb-0">
            {isDragging ? "Drop files here..." : "Drag & drop files here, or click to select"}
          </p>
        </div>

        {/* File table */}
        <div className="table-responsive">
          <table className="table table-striped align-items-center table-flush mt-2 bg-white border">
            <thead className="thead-light">
              <tr>
                <th>S.No.</th>
                <th>Document Name</th>
                <th>Size</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {documents &&
                documents.map((item, key) => (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>{item.name}</td>
                    <td>{this.convertToBytes(item.size)}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-link"
                        title="Remove"
                        onClick={() => handleFileRemove(item)}
                      >
                        <i className="fa fa-times text-red" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default UploadDocument;
